export default "__VITE_ASSET__45b5d0c0__"